import React from 'react'
import {createIcon} from '@chakra-ui/react'

export const SwapVerticalIcon = createIcon({
  displayName: 'SwapVerticalIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M16 17.01V10H14V17.01H11L15 21L19 17.01H16ZM9 3L5 6.99H8V14H10V6.99H13L9 3ZM16 17.01V10H14V17.01H11L15 21L19 17.01H16ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z"
      fill="black"
    />
  ),
})
